import React, { useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { getVideoUrl } from '../utils/api';

const Hero = ({ onOpenModal }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.75;
    }
  }, []);

  const scrollToProducts = () => {
    document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Video with Overlay */}
      <div className="absolute inset-0 z-0">
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="/videos/hero-video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary-900/60 via-primary-800/40 to-transparent" />
        {/* Texture Overlay */}
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Main Heading */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            style={{ paddingTop: '25px' }}
          >
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
              <span className="block text-primary-200" style={{fontFamily: 'Dancing Script, cursive'}}>PREMIUM FLORALS</span>
              <span className="block text-primary-200" style={{fontFamily: 'Dancing Script, cursive'}}>&</span>
              <span className="block">EVENT DESIGN</span>
            </h1>
          </motion.div>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-xl md:text-2xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed"
          >
            Melbourne's one stop destination for luxury artificial floral hire, seasonal fresh floral artistry and unique event furnishings.
          </motion.p>

          {/* CTA Button */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12"
          >
            <button
              onClick={scrollToProducts}
              className="btn bg-accent-purple-500 hover:bg-accent-purple-600 text-white text-lg px-8 py-4 min-w-[200px] group"
            >
              Explore Collection
              <motion.span
                className="inline-block ml-2"
                animate={{ x: [0, 4, 0] }}
                transition={{ duration: 1.5, repeat: Infinity }}
              >
                →
              </motion.span>
            </button>
          </motion.div>
        </div>
      </div>


      {/* Decorative Elements */}
      <div className="absolute top-1/4 left-8 w-1 h-32 bg-primary-300 opacity-50 hidden lg:block" />
      <div className="absolute top-1/3 right-8 w-1 h-24 bg-primary-200 opacity-30 hidden lg:block" />
      <div className="absolute bottom-1/4 left-16 w-2 h-2 bg-primary-300 rounded-full opacity-60 hidden lg:block" />
      <div className="absolute bottom-1/3 right-20 w-1 h-1 bg-primary-200 rounded-full opacity-40 hidden lg:block" />
    </section>
  );
};

export default Hero;